import { render } from "./mvt-dialog.vue?vue&type=template&id=6778573e"
import script from "./mvt-dialog.js?vue&type=script&lang=js"
export * from "./mvt-dialog.js?vue&type=script&lang=js"

import "./mvt-dialog.vue?vue&type=style&index=0&id=6778573e&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__